import React from "react";
import PropTypes from "prop-types";

function Image({ src, className }) {
  return <img src={`/images/${src}`} className={className} alt="basic" />;
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
};
Image.defaultProps = {
  className: "img-fuild",
};

export { Image };
